import React, { useState, useEffect } from 'react';
import { Grid, Card, CardContent, Typography, Chip, Box, MenuItem, FormControl, InputLabel, Select, Button } from '@mui/material';
import { CalendarToday, AccessTime, Person, LocalShipping } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import Navbar from '../Navbar/Navbar';
import EstatusModalServ from './EstatusModalServ';
import OrdenServicioCentroCamioneroModal from './CCformulario';
import OrdenServicioUnidadMovil from './UniMovilformulario';
import { useCarrito } from '../context/CarritoContext';
import AssignmentIcon from '@mui/icons-material/Assignment';

const Servicios = () => {
  const [filtroTipo, setFiltroTipo] = useState('');
  const { rol } = useCarrito();
  const nombreCliente = sessionStorage.getItem('Nombre');
  const [sucursal, setSucursal] = useState("");
  const [citas, setCitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
  const [modalEstatusOpen, setModalEstatusOpen] = useState(false);
  const [citaParaEstatus, setCitaParaEstatus] = useState(null);
  const [modalOrdenCCOpen, setModalOrdenCCOpen] = useState(false);
  const [modalOrdenUniOpen, setModalOrdenUniOpen] = useState(false);
  const [idCitaSeleccionada, setIdCitaSeleccionada] = useState(null);
  const [ordenAccion, setOrdenAccion] = useState('ver');
  const [idOrdenServicio, setIdOrdenServicio] = useState(null);


  const handleAbrirModalCentroCamionero = (cita) => {
    setIdCitaSeleccionada(cita.IdCita);
    setModalOrdenCCOpen(true);
  };

  const handleAbrirModalUnidadMovil = (cita) => {
    setIdCitaSeleccionada(cita.IdCita);
    setModalOrdenUniOpen(true);
  };


  const abrirModalEstatus = (pedido) => {
    setCitaParaEstatus(pedido);
    setModalEstatusOpen(true);
  };

  const cerrarModalEstatus = () => {
    setModalEstatusOpen(false);
    setCitaParaEstatus(null);
  };

  const recargarCitas = () => {
    fetch('https://bibliotecadlago.com/php/Backend/obtener_todascitas.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(res => res.json())
      .then(data => {
        setCitas(data);
        setLoading(false);
      })
      .catch(() => {
        setCitas([]);
        setLoading(false);
      });
  };


  const handleAbrirModal = async (cita) => {
    try {
      let url = ''
      if (cita.tipo.toLowerCase() === 'centro camionero') {
        url = 'https://bibliotecadlago.com/php/Backend/obtenerOrdenesCita.php'
      } else {
        url = 'https://bibliotecadlago.com/php/Backend/obtenerOrdenesCitaUM.php'
      }
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ IdCita: cita.IdCita }),
      });

      const result = await response.json();

      if (result.success) {
        setDetalleSeleccionado({
          idCita: cita.IdCita,
          estatus: cita.Estatus,
          ordenes: result.ordenes,
          tipo: cita.tipo,
          estado: cita.estado,
        });
      } else {
        setDetalleSeleccionado({
          idCita: cita.IdCita,
          estatus: cita.Estatus,
          estado: cita.estado,
          ordenes: [],
          tipo: cita.tipo,
        });
      }

      setModalOpen(true);
    } catch (error) {
      console.error('Error al obtener ordenes:', error);
      setDetalleSeleccionado({
        idCita: cita.IdCita,
        estatus: cita.Estatus,
        ordenes: [],
        tipo: cita.tipo,
        estado: cita.estado,
      });
      setModalOpen(true);
    }
  };


  useEffect(() => {
    recargarCitas();
  }, []);

  const handleFilterChange = (event) => {
    setFiltroTipo(event.target.value);
  };

  const citasFiltradas = filtroTipo
    ? citas.filter(cita => cita.tipo.toLowerCase() === filtroTipo.toLowerCase()).filter((cita) => rol !== 'Cliente' || cita.nombre_usuario === nombreCliente)
    : citas.filter((cita) => rol !== 'Cliente' || cita.nombre_usuario === nombreCliente);

  const hoy = new Date();
  const formatoHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;

  const estadoColor = {
    Confirmada: 'secondary',
    'En proceso': 'info',
    Finalizado: 'success',
    Solicitado: 'warning',
    Cancelado: 'error',
  };

  const columns = [
    { field: 'IdCita', headerName: 'Id', width: 70 },
    { field: 'tipo', headerName: 'Tipo', width: 160 },
    { field: 'Fecha', headerName: 'Fecha', width: 130 },
    { field: 'hora', headerName: 'Hora', width: 100 },
    { field: 'estado', headerName: 'Estado', width: 100 },
    { field: 'Ubicacion', headerName: 'Ubicacion', width: 180 },
    { field: 'nombre_usuario', headerName: 'Cliente', width: 180 },
    {
      field: 'Estatus',
      headerName: 'Estatus',
      width: 130,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={estadoColor[params.value]}
          size="small"
        />
      ),
    },
    {
      field: 'verOrden',
      headerName: 'Orden',
      width: 300,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={() => handleAbrirModal(params.row)}
          >
            <AssignmentIcon sx={{ color: '#cf1316' }} />
          </IconButton>
          {rol !== 'Cliente' && (
            <Button
              variant="contained"
              size="small"
              onClick={() => abrirModalEstatus(params.row)}
              sx={{
                marginRight: 1,
                backgroundColor: '#cf1316',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#a30f11',
                },
              }}
            >
              Cambiar Estatus
            </Button>
          )}
        </>
      ),
    }

  ];

  if (loading) {
    return (
      <>
        <Navbar />
        <Box sx={{ padding: 3, textAlign: 'center' }}>
          <Typography variant="h6">Cargando citas...</Typography>
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Box sx={{ padding: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h4" sx={{ color: '#cf1316', fontWeight: 'bold' }}>
            Lista de Servicios
          </Typography>

          <button
            onClick={() => navigate('/agendar')}
            style={{
              backgroundColor: '#cf1316',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '16px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              transition: 'background 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#a30f11')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#cf1316')}
          >
            + Generar Cita
          </button>
        </Box>

        {/* Filtro por tipo */}
        <FormControl sx={{ width: '80%', mb: 2 }}>
          <InputLabel>Tipo</InputLabel>
          <Select
            name="tipo"
            value={filtroTipo}
            onChange={handleFilterChange}
            label="Tipo"
          >
            <MenuItem value="">Todas</MenuItem>
            <MenuItem value="Centro Camionero">Centro Camionero</MenuItem>
            <MenuItem value="Unidad Movil">Unidad Móvil</MenuItem>
            {/*
            <MenuItem value="Renovado MRT">Renovado MRT</MenuItem>
            <MenuItem value="Ingenieria de Campo">Ingenieria de Campo</MenuItem>
            <MenuItem value="Pila de Desecho">Pila de Desecho</MenuItem>
            */}
          </Select>
        </FormControl>

        <Typography variant="h5" gutterBottom>
          📋 Citas de hoy
        </Typography>

        {/* Cartas de citas del día de hoy */}
        <Grid container spacing={3} mb={5}>
          {citasFiltradas
            .filter((cita) => cita.Fecha === formatoHoy)
            .map((cita) => (
              <Grid item xs={12} sm={6} md={4} key={cita.IdCita}>
                <Card sx={{
                  minHeight: 240,
                  maxWidth: 400,
                  border: '1px solid #1a181c',
                  borderRadius: 1,
                }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {cita.tipo.toLowerCase() === 'centro camionero' ? (
                        <LocalShipping sx={{ mr: 1, verticalAlign: 'middle' }} />
                      ) : '🚐'}
                      {cita.tipo}
                    </Typography>

                    <Box display="flex" alignItems="center" mb={1}>
                      <CalendarToday sx={{ fontSize: 20, mr: 1 }} />
                      <Typography>{cita.Fecha}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" mb={1}>
                      <AccessTime sx={{ fontSize: 20, mr: 1 }} />
                      <Typography>{cita.hora}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" mb={1}>
                      <Person sx={{ fontSize: 20, mr: 1 }} />
                      <Typography>{cita.nombre_usuario}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" mb={1}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Estado:
                      </Typography>
                      <Typography>{cita.estado}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" mb={1}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Ubicación:
                      </Typography>
                      <Typography>{cita.Ubicacion}</Typography>
                    </Box>

                    <Chip
                      label={cita.Estatus}
                      color={estadoColor[cita.Estatus]}
                      size="small"
                    />
                    {rol !== 'Cliente' && (
                      <Button
                        variant="contained"
                        size="small"
                        fullWidth
                        onClick={() => abrirModalEstatus(cita)}
                        sx={{
                          mt: 2,
                          backgroundColor: '#db071c',
                          color: '#fff',
                          '&:hover': {
                            backgroundColor: '#b80819ff',
                          },
                        }}
                      >
                        Cambiar Estatus
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      fullWidth
                      size="small"

                      sx={{ mt: 2, backgroundColor: '#db071c', color: 'white' }}
                      onClick={() => handleAbrirModal(cita)}
                    >
                      Ver {rol !== 'Cliente' && ('/ Crear')} Orden
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>

        <Typography variant="h5" gutterBottom>
          📊 Lista de Citas
        </Typography>

        {/* DataGrid */}
        <Box sx={{ height: 400, width: '100%' }}>
          <DataGrid
            rows={citasFiltradas}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableRowSelectionOnClick
            getRowId={(row) => row.IdCita}
          />
        </Box>
      </Box>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          Detalles de Orden
          <IconButton
            aria-label="close"
            onClick={() => setModalOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>Estatus de la cita:</strong> {detalleSeleccionado?.estatus}
          </Typography>

          {detalleSeleccionado?.ordenes?.length > 0 ? (
            detalleSeleccionado.ordenes.map((orden, index) => (
              <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ddd', borderRadius: '8px' }}>
                <Typography variant="body2">
                  <strong>Folio:</strong> {detalleSeleccionado.tipo === 'centro camionero' ? orden.IdCentroCamionero : orden.IdUnidadMovil}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}><strong>Estatus:</strong> {orden.Estatus}</Typography>
                <Button
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    color: '#db071c',
                    borderColor: '#db071c',
                    '&:hover': {
                      backgroundColor: 'rgba(219, 7, 28, 0.04)',
                      borderColor: '#db071c',
                    },
                  }}
                  onClick={() => {
                    setModalOpen(false);
                    console.log(idOrdenServicio)
                    setIdOrdenServicio(orden.IdCentroCamionero)
                    setOrdenAccion('ver')
                    if (detalleSeleccionado.tipo.toLowerCase() === 'centro camionero') {
                      setIdOrdenServicio(orden.IdCentroCamionero)
                      handleAbrirModalCentroCamionero({ IdCita: detalleSeleccionado.idCita });
                    } else {
                      setSucursal(detalleSeleccionado.estado)
                      setIdOrdenServicio(orden.IdUnidadMovil)
                      handleAbrirModalUnidadMovil({ IdCita: detalleSeleccionado.idCita });
                    }
                  }}
                >
                  Ver Orden
                </Button>
                {(rol !== 'Cliente' && rol !== 'Mecanico') && (orden.Estatus !== 'Completado') && (
                  <Button
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{
                      color: '#db071c',
                      borderColor: '#db071c',
                      '&:hover': {
                        backgroundColor: 'rgba(219, 7, 28, 0.04)',
                        borderColor: '#db071c',
                      },
                    }}
                    onClick={() => {
                      setModalOpen(false);
                      setOrdenAccion('completar')
                      setIdOrdenServicio(orden.IdCentroCamionero)
                      if (detalleSeleccionado.tipo.toLowerCase() === 'centro camionero') {
                        setIdOrdenServicio(orden.IdCentroCamionero)
                        handleAbrirModalCentroCamionero({ IdCita: detalleSeleccionado.idCita });
                      } else {
                        setSucursal(detalleSeleccionado.estado)
                        setIdOrdenServicio(orden.IdUnidadMovil)
                        handleAbrirModalUnidadMovil({ IdCita: detalleSeleccionado.idCita });
                      }
                    }}
                  >
                    Completar
                  </Button>
                )}

              </Box>
            ))
          ) : (
            <Typography variant="body2">No hay órdenes aún para esta cita.</Typography>
          )}
        </DialogContent>


        <DialogActions>
          {rol !== 'Cliente' && (
            <Button
              variant="contained"
              onClick={() => {
                setModalOpen(false);
                setOrdenAccion('crear')
                setIdOrdenServicio(null)
                if (detalleSeleccionado.tipo.toLowerCase() === 'centro camionero') {
                  handleAbrirModalCentroCamionero({ IdCita: detalleSeleccionado.idCita });
                } else {
                  setSucursal(detalleSeleccionado.estado)
                  handleAbrirModalUnidadMovil({ IdCita: detalleSeleccionado.idCita });
                }
              }}
              sx={{ backgroundColor: '#db071c', color: 'white' }}
            >
              Crear Orden
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {citaParaEstatus && (
        <EstatusModalServ
          open={modalEstatusOpen}
          onClose={cerrarModalEstatus}
          idCita={citaParaEstatus.IdCita}
          estatusActual={citaParaEstatus.Estatus}
          onActualizar={() => {
            cerrarModalEstatus();
            recargarCitas();
          }}
        />
      )}
      {modalOrdenCCOpen && (
        <OrdenServicioCentroCamioneroModal
          open={modalOrdenCCOpen}
          onClose={() => setModalOrdenCCOpen(false)}
          idCita={idCitaSeleccionada}
          onSuccess={() => {
            setModalOrdenCCOpen(false);
            recargarCitas();
          }}
          accion={ordenAccion}
          Id={idOrdenServicio}
          Suscursl={sucursal}
        />
      )}
      {modalOrdenUniOpen && (
        <OrdenServicioUnidadMovil
          open={modalOrdenUniOpen}
          onClose={() => setModalOrdenUniOpen(false)}
          idCita={idCitaSeleccionada}
          onSuccess={() => {
            setModalOrdenUniOpen(false);
            recargarCitas();
          }}
          accion={ordenAccion}
          Id={idOrdenServicio}
          Sucursal={sucursal}
        />
      )}


    </>
  );
};

export default Servicios;
